import api from './api';

export const getDecodeOptimization = (cameraId) =>
  api.get(`/admin/cameras/${cameraId}/decode-optimization`).then((r) => r.data);

export const updateDecodeOptimization = (cameraId, payload) =>
  api.put(`/admin/cameras/${cameraId}/decode-optimization`, payload).then((r) => r.data);

export const probeDecodeOptimization = (cameraId, durationSeconds = 20) =>
  api.post(`/admin/cameras/${cameraId}/decode-optimization/probe`, {
    duration_seconds: durationSeconds,
  }).then((r) => r.data);

export const reprobeDecodeOptimization = (cameraId, reason = 'admin_retry') =>
  api.post(`/admin/cameras/${cameraId}/decode-optimization/reprobe`, { reason }).then((r) => r.data);
